// import 'core-js/stable';
import "core-js";
import 'regenerator-runtime/runtime';

import Vue from 'vue';
import App from './App.vue';
import router from './router';
import filters from "./filters";
import {createPinia, PiniaVuePlugin} from "pinia";
import VueRouter from "vue-router";
import {client} from "@/libraries/http"
import useAuthnStore from "@/store/authn";
import {Toast} from "vant";
import vhCheck from "vh-check";
import VConsole from 'vconsole';
import smoothscroll from 'smoothscroll-polyfill';

import 'vant/lib/index.css';

smoothscroll.polyfill();

if (process.env.VUE_APP_DEBUG_CONSOLE) {
    new VConsole();
}

vhCheck();

// document.addEventListener('scroll', () => {
//     vhCheck().recompute()
// })

Vue.config.productionTip = false;

Vue.use(filters);

Vue.use(PiniaVuePlugin);
const pinia = createPinia();

Vue.use(VueRouter)

function showLoading({disableToast, toastMessage}) {
    if (disableToast) return
    Toast.loading({
        message: toastMessage || '加载中...',
        forbidClick: true,
        loadingType: 'spinner',
        duration: 0
    });
}

function clearLoading(disableToast) {
    if (disableToast) return
    Toast.clear();
}

function showToast(message, disableToast) {
    if (disableToast) return
    Toast(message);
}

client.interceptors.request.use((config) => {
    const authn = useAuthnStore();
    if (authn.authorization) {
        config.headers.Authorization = authn.authorization;
    }
    showLoading({
        disableToast: config.headers['Disable-Loading'],
        toastMessage: config.headers['Toast-Message'] && decodeURI(config.headers['Toast-Message'])
    });
    return config;
});

client.interceptors.response.use(
    (res) => {
        // if (Number.parseInt(res.data?.status) !== 200) {
        //     Toast.fail(res.data.message)
        //     return Promise.reject(res);
        // }
        return Promise.resolve(res).finally(() => clearLoading(res.config.headers['Disable-Loading']));
    },
    (err) => {
        //console.error(err);
        clearLoading();
        //console.log(router.history.current.meta)
        const authn = useAuthnStore();
        if (err.response.status === 401 || err.response.status === 403) {
            showToast("您的登录已经过期，请重新登录")
            if(router.history.current.meta.type === 'guard'){
                authn.logout();
                router.push({
                    path: '/',
                    query: {
                        type: 'guard'
                    } 
                });
            }else if(router.history.current.meta.type === 'external'){
                authn.logout();
                router.push({
                    path: '/scanVerify/chargePhone',
                    query: {
                        isInvoice: true
                    } 
                });
            }else {
                authn.logout();
                router.go(0);
            }
            
            return Promise.reject(err);
        }
        if (err.response.data?.message) {
            // const data = {
            //     message: err.response.data?.message || '请求失败，请刷新页面重试',
            //     code: err.response.status !== 200 ? err.response.status : Number.parseInt(err.response.data.code)
            // }
            showToast(err.response.data?.message, err.config.headers['Disable-Toast'])
            return Promise.reject(err);
        }
        showToast(err.message, err.config.headers['Disable-Toast'])
        return Promise.reject(err);
    });

new Vue({
    pinia,
    router,
    render: h => h(App),
}).$mount('#app')

// wx.ready(function () {
//     // config信息验证后会执行ready方法，所有接口调用都必须在config接口获得结果之后，config是一个客户端的异步操作，所以如果需要在页面加载时就调用相关接口，则须把相关接口放在ready函数中调用来确保正确执行。对于用户触发时才调用的接口，则可以直接调用，不需要放在ready函数中。
// });
// wx.error(function (res) {
//     console.log(res);
//     // console.log((res.errMsg)
//     // config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
// });

// client.interceptors.response.use((config) => {
//   const authn = useAuthnStore();
//   if (authn.authorization) {
//     config.headers.Authorization = authn.authorization;
//   }
//   console.log(authn)
//   return config;
// });

// client.get('/api/admin/sysUser/front/menu/all', {
//   firstName: 'Fred',
//   lastName: 'Flintstone'
// })
//     .then(function (response) {
//       console.log(response);
//     })
//     .catch(function (error) {
//       console.log(error);
//     });
